import React from "react";
import { useLang } from "../../lib/i18n";
import { Reveal } from "../motion/Reveal";
import { SectionKicker } from "./Manifesto";

export const WhyGreen = () => {
  const { t } = useLang();
  return (
    <section id="why" className="relative z-10 py-24 md:py-32 border-t border-white/10 bg-[#161616]" data-testid="why-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <SectionKicker>{t.why.kicker}</SectionKicker>
          <h2 className="font-display font-extrabold tracking-tighter text-4xl md:text-6xl max-w-3xl leading-[0.95]">
            {t.why.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden">
          {t.why.stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="bg-[#161616] hover:bg-[#1e1e1e] transition-colors duration-500 p-7 md:p-10 h-full">
                <p className="font-display text-5xl md:text-7xl font-extrabold text-lime2 tracking-tighter">
                  {s.v}
                </p>
                <p className="mt-4 text-white/60 text-sm md:text-base leading-snug max-w-[180px]">{s.l}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
